import styled from '@emotion/styled';

const PortfolioWrapper = styled('div')({
  position: 'relative',
});

export default PortfolioWrapper;
